import { FormEvent } from "react"
import classNames from "classnames"

import { ApiTypes } from "types"

import { InputNew } from "components/form/InputNew"
import { InputPhone } from "components/form/InputPhone"

import { CustomerCommonValues } from "."

import styles from "./index.module.scss"

interface Props {
  customer: ApiTypes.Model.ClientDevices
  commonValues: CustomerCommonValues
  hideTab: boolean
  onCommonValuesChange: (event: FormEvent<HTMLInputElement>) => void
  setCommonValues: (value: CustomerCommonValues) => void
  error: {
    field: string
    message: string
  }
}

const CustomerInformation = ({
  commonValues,
  error,
  customer,
  hideTab,
  onCommonValuesChange,
  setCommonValues,
}: Props) => {
  return (
    <aside className={classNames(styles.modalSidebar, { [styles.hideTab]: hideTab })}>
      <h4 className={styles.sidebarSubtitle}>Customer information</h4>
      <div className={styles.modalFieldWrapper}>
        <span className={styles.modalFieldLabel}>Customer ID</span>
        <span className={styles.modalFieldValue}>{commonValues.homeownerID}</span>
      </div>
      <div className={styles.modalFieldWrapper}>
        <span className={styles.modalFieldLabel}>Full Name</span>
        <InputNew
          placeholder="Enter Full Name"
          name="fullName"
          value={commonValues.fullName}
          onChange={onCommonValuesChange}
          errorMessage={error.field === "fullName" ? error.message : ""}
        />
      </div>
      <div className={styles.modalFieldWrapper}>
        <span className={styles.modalFieldLabel}>Devices</span>
        <span className={styles.modalFieldValue}>{customer.devices?.length}</span>
      </div>
      <div className={classNames(styles.modalFieldWrapper, styles.inputLabelWrapper)}>
        <span className={styles.modalFieldLabel}>Email</span>
        <InputNew
          label=""
          className={styles.emailInput}
          placeholder="Enter email"
          name="email"
          onChange={onCommonValuesChange}
          value={commonValues?.email}
          errorMessage={error.field === "email" ? error.message : ""}
        />
      </div>
      <div className={classNames(styles.modalFieldWrapper, styles.inputLabelWrapper)}>
        <span className={styles.modalFieldLabel}>Phone number</span>
        <InputPhone
          label=""
          placeholder="Enter phone number"
          name="phone"
          onChange={value => setCommonValues({ ...commonValues, ...{ phone: value } })}
          value={commonValues.phone}
          errorMessage={error.field === "phone" ? error.message : ""}
        />
      </div>
    </aside>
  )
}

export default CustomerInformation
